export default function Error() {
  return (
    <div className="">
      <div className="">
        <p>ERROR</p>
      </div>
    </div>
  );
}
